<template>
  <Navbar />
  <div class="main_section">
    <div class="title col">
      <h1>
        檢視維修
      </h1>
    </div>
    <div class="info_wrap col">
      <!-- 維修編號，申請人員，申請日期 -->
      <div class="fixed_info">
        <div>
          <p>
            維修編號 : {{ Form.RepairId }}
          </p>
        </div>
        <div>
          <p>
            申請人員 : {{ Form.ApplicantNickName }}
          </p>
        </div>
        <div>
          <p>
            申請日期 : {{ Form.ApplicationDate }}
          </p>
        </div>
      </div>
      <div class="content">
        <!-- 物品名稱 -->
        <div class="col-12">
          <div class="input-group mb-4">
            <div class="input-group-prepend">
              物品名稱：
            </div>
            <input type="text" class="form-control readonly_box" readonly v-model="Form.AssetName">
          </div>
        </div>
        <div class="row g-0">
          <!-- 資產編號 -->
          <div class="col-xl-6 col-lg-6 col-md-6 col-12">
            <div class="input-group mb-4">
              <div class="input-group-prepend">
                資產編號：
              </div>
              <input type="text" class="form-control readonly_box" readonly v-model="Form.AssetsId">
            </div>
          </div>
          <!-- 送修人員 -->
          <div class="col-xl-6 col-lg-6 col-md-6 col-12">
            <div class="input-group mb-4">
              <div class="input-group-prepend">
                送修人員：
              </div>
              <input type="text" class="form-control readonly_box" readonly v-model="Form.RepairPersonNickName">
            </div>
          </div>
        </div>
        <!-- 問題描述 -->
        <div class="col-12">
          <div class="input-group d-flex">
            <div class="input-group-prepend">問題描述：</div>
            <textarea style="height: 200px;" class="form-control readonly_box" readonly>{{ Form.Question }}</textarea>
          </div>
        </div>
        <!-- 報修照片 -->
        <div class="col-12 repair_photo_section">
          <div class="input-group mt-3">
            <div class="input-group-prepend">報修照片：</div>
          </div>
          <swiper-container class="swiper_section" :autoHeight="true" :space-between="40"
            :pagination="{ clickable: true, }" :modules="[Pagination]"
            :breakpoints="{ 0: { slidesPerView: 1, }, 768: { slidesPerView: 3, }, 1200: { slidesPerView: 3, }, }">
            <swiper-slide v-for="(item, index) in Form.existFile" :key="index">
              <img class="swiper_bottom_img" :src="item.FileLink">
              <button class='zoom_img' @click="utilsStore.viewFile(item)">
                <img src="@/assets/zoom.png">
              </button>
            </swiper-slide>
          </swiper-container>
          <div class="swiper_pagination"></div>
        </div>
      </div>
      <div class="fixed_info mt-5">
        <p>維修資訊</p>
      </div>
      <div class="content">
        <!-- 維修廠商 -->
        <div class="col-12">
          <div class="input-group mb-4">
            <div class="input-group-prepend">
              維修廠商：
            </div>
            <input type="text" class="form-control readonly_box" readonly v-model="Form.RepairCompany">
          </div>
        </div>
        <!-- 外部維修單號 -->
        <div class="col-12">
          <div class="input-group mb-4">
            <div class="input-group-prepend">
              外部維修單號：
            </div>
            <input type="text" class="form-control readonly_box" readonly v-model="Form.ExternalRepairId">
          </div>
        </div>
        <div class="row g-0">
          <!-- 廠商聯絡人 -->
          <div class="col-xl-6 col-lg-6 col-md-6 col-12">
            <div class="input-group mb-4">
              <div class="input-group-prepend">
                廠商聯絡人：
              </div>
              <input type="text" class="form-control readonly_box" readonly v-model="Form.ContactPerson">
            </div>
          </div>
          <!-- 聯絡電話 -->
          <div class="col-xl-6 col-lg-6 col-md-6 col-12">
            <div class="input-group mb-4">
              <div class="input-group-prepend">
                聯絡電話：
              </div>
              <input type="text" class="form-control readonly_box" readonly v-model="Form.ContactPhone">
            </div>
          </div>
        </div>
        <div class="row g-0">
          <!-- 預計歸還日期 -->
          <div class="col-xl-6 col-lg-6 col-md-6 col-12">
            <div class="input-group d-flex mb-4">
              <div class="input-group-prepend">
                預計歸還日期：
              </div>
              <input type="text" class="form-control readonly_box" readonly v-model="Form.RepairDate">
            </div>
          </div>
          <!-- 送修日期 -->
          <div class="col-xl-6 col-lg-6 col-md-6 col-12">
            <div class="input-group d-flex mb-4">
              <div class="input-group-prepend">
                送修日期：
              </div>
              <input type="text" class="form-control readonly_box" readonly v-model="Form.RepairDate">
            </div>
          </div>
        </div>
        <!-- 備註 -->
        <div class="col-12">
          <div class="input-group d-flex">
            <div class="input-group-prepend">
              備註：
            </div>
            <textarea style="height: 200px;" class="form-control readonly_box" readonly> {{ Form.Memo }}</textarea>
          </div>
        </div>
        <!-- 已上傳文件 -->
        <div class="col-12 repair_photo_section">
          <div class="input-group mt-3">
            <div class="input-group-prepend">已上傳文件：</div>
            <div class="selected_file">
              <!-- v-for讀取已上傳物流文件 -->
              <div class="file_upload_wrap" v-for="(file, index) in Form.existRepairDocument" :key="index">
                <p>{{ file.FileName }}
                  <!-- 在handlePreview依據不同副檔名做不同處理 -->
                  <img class="view_icon" src="@/assets/view.png" style="margin-left: 10px;cursor: pointer;"
                    @click="utilsStore.viewFile(file)">
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="fixed_info mt-5">
        <div>
          <p>
            歸還與驗收
          </p>
        </div>
      </div>
      <div class="content">
        <div class="row g-0">
          <!-- 歸還人員 -->
          <div class="col-xl-6 col-lg-6 col-md-6 col-12">
            <div class="input-group mb-4">
              <div class="input-group-prepend">歸還人員 :</div>
              <div class="form-control readonly_box">{{ Form.ReturnPersonNickName }}</div>
            </div>
          </div>
          <!-- 歸還日期 -->
          <div class="col-xl-6 col-lg-6 col-md-6 col-12">
            <div class="input-group mb-4">
              <div class="input-group-prepend">歸還日期 :</div>
              <div class="form-control readonly_box">{{ Form.ReturnDate }}</div>
            </div>
          </div>
        </div>
        <div class="row g-0">
          <!-- 歸還區域 -->
          <div class="col-xl-6 col-lg-6 col-md-6 col-12">
            <div class="input-group mb-4">
              <div class="input-group-prepend">歸還區域 :</div>
              <div class="form-control readonly_box">{{ Form.AreaName }}</div>
            </div>
          </div>
          <!-- 歸還櫃位 -->
          <div class="col-xl-6 col-lg-6 col-md-6 col-12">
            <div class="input-group mb-4">
              <div class="input-group-prepend">歸還櫃位 :</div>
              <div class="form-control readonly_box">{{ Form.LayerName }}</div>
            </div>
          </div>
        </div>
        <!-- 備註 -->
        <div class="col-12">
          <div class="input-group d-flex mb-4">
            <div class="input-group-prepend">驗收備註 :</div>
            <textarea style="height: 200px;" class="form-control readonly_box" readonly v-model="Form.Memo"></textarea>
          </div>
        </div>
        <!-- 驗收文件 -->
        <!-- 已上傳文件 -->
        <div class="col selected_file">
          <div class="input-group">
            <div class="input-group-prepend">已上傳文件 :</div>
            <div class="selected_file_wrap col">
              <div v-for="(file, index) in Form.existReturnDocument" :key="index" class="file_upload_wrap">
                <p>{{ file.FileName }}
                  <img class="view_icon" src="@/assets/view.png" style="margin-left: 10px;"
                    @click="utilsStore.viewFile(file)">
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col button_wrap">
        <button class="back_btn" @click="utilsStore.goBack">回上一頁</button>
      </div>
    </div>
  </div>
  <view_modal></view_modal>
  <button type="button" id="openModal" data-bs-toggle="modal" data-bs-target="#viewFile_modal" class="d-none">modal button</button>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router'
import view_modal from '@/components/view_modal.vue';
import Navbar from '@/components/Navbar.vue';
import { useRepairStore } from '@/store/repair/_index';
import { useUtilsStore } from '@/store';
import { storeToRefs } from 'pinia';
import { register } from 'swiper/element/bundle';
import { Pagination } from 'swiper/modules';
const route = useRoute();
const RepairId = route.query.search_id;
const utilsStore = useUtilsStore();
const repairStore = useRepairStore();
const {
  Form,
} = storeToRefs(repairStore);
onMounted(() => {
  register();
  repairStore.$reset();
  repairStore.getDetails(RepairId)
});
onUnmounted(() => {
  repairStore.$dispose();
})
</script>


<style lang="scss" scoped>
@import '@/assets/css/global.scss';

span {
  @include red_star
}

.input-number {
  @include count_btn;
}

.readonly_box {
  @include readonly_box;
}

.form-check-input {
  align-self: center
}

.view_icon,
.trash_icon {
  cursor: pointer
}

.modal {
  .modal-body {
    padding: 20px;
    margin: auto;
  }

  .modal-content {
    margin: auto;
  }

  .modal-input-group-prepend {
    width: auto;
    font-weight: 700;
    font-size: 20px;
  }

  .modal-footer {
    padding: 0 12px 12px;
    border: none;
  }

  .modal-header {
    h5 {
      font-weight: 700;
    }

    background: #528091;
    color: white;
    display: flex;
    justify-content: center;

    .close_icon {
      cursor: pointer;
    }
  }
}

.custom-slide {
  display: flex;
  align-self: center;
}

.button_wrap {
  display: flex;
  justify-content: space-between;
  margin: 30px auto 5%;
  width: 210px;

  .back_btn {
    @include back_to_previous_btn;

    &:hover {
      background-color: #5d85bb;
    }
  }

  .send_btn {
    @include search_and_send_btn;

    &:hover {
      background-color: #5e7aa2;
    }
  }
}

.main_section {

  .info_wrap {
    .swiper_section {
      swiper-slide img {
        width: 100%;
        height: auto;
        padding: 40px 0;
      }
    }

    .fixed_info {
      @include fixed_info;

      p {
        font-size: 20px;
        margin-bottom: 0;
      }
    }

    .content {
      @include content_bg;

      .input-group {

        .readonly_box,
        .form-control {
          height: 35px;
          border-radius: 0;
        }

        .input-group-prepend {
          color: white;
          font-weight: 700;
          font-size: 20px;
        }
      }

      .selected_file {
        .file_upload_wrap {
          margin-bottom: 0;
          display: flex;

          img {
            width: 25px;
            height: 25px;
          }

          p {
            font-weight: 700;
            margin-bottom: 5px;
            color: white;
            word-break: break-word;

            &::before {
              margin-right: 10px;
              content: '·';
              font-weight: 700;
              color: white;
            }
          }
        }
      }

      .file_wrap {
        display: flex;
        flex-direction: column;

        .choose_btn {
          margin-bottom: 10px;
          @include choose_file_btn;

          &:hover {
            background: #3f608f;
          }
        }
      }
    }


  }
}

@media only screen and (min-width: 1200px) {
  .main_section {

    .swiper_section {
      swiper-slide img {
        padding: 40px 0;
      }
    }

    .info_wrap {
      margin: 8px auto 5%;
      width: 800px;

      .content {
        .input-group {
          flex-wrap: nowrap;



          .input-group-prepend {
            text-align: end;
            width: 155px;
          }
        }


      }
    }
  }
}

@media only screen and (min-width: 768px) and (max-width: 1199px) {
  .main_section {

    .swiper_section {
      swiper-slide img {
        padding: 40px 0;
      }
    }

    .info_wrap {
      margin: 8px auto 5%;
      padding: 0 5%;

      .content {
        .input-group {
          width: 100%;
          flex-wrap: nowrap;

          .input-number,
          .readonly_box {
            width: 100%;
          }

          .form-control {
            width: 54%;
          }

          .input-group-prepend {
            text-align: end;
            width: 145px;
          }
        }


      }

      .content:nth-child(4) {
        .input-group-prepend {
          width: 160px;
        }

        .input-group .form-control {
          width: 50%;
        }
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .main_section {

    .readonly_box,
    .form-control,
    .form-select,
    .input-number {
      margin-left: unset !important;
    }

    .swiper_section {
      swiper-slide img {
        padding: 40px;
      }
    }

    .info_wrap {
      padding: 0 5%;

      .fixed_info {
        height: unset;
        flex-direction: column;
        padding: 10px;

      }

      .content {
        .input-group {
          flex-direction: column;

          .input-group> :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
            margin-left: unset;
            border-radius: 5px;
            margin-top: 5px;
            height: 35px;
          }

          .form-control,
          .form-select {
            width: 100%;
          }

          .input-group-prepend {
            margin-bottom: 5px;
            width: 100px;
            white-space: nowrap;
          }
        }

        .selected_file {
          .input-group {
            flex-direction: column;
          }

        }

        .file_wrap {
          margin-left: unset !important;

          .choose_btn {
            margin-top: 5px;

          }
        }
      }
    }
  }
}
</style>